import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle,
    Label,Button
} from "reactstrap"
import { Preview } from '../../../../../helpers/ui/FileInput'
import { Link, useHistory, Redirect } from "react-router-dom"

import apiResponse from '../../../../../services/apiResponse'
import { cancelToken } from '../../../../../services/adapters/kepegawaian/kursusService'

// import PegawaiSideBar from "../../GlobalComponents/PegawaiSidebar"

import IndexBloc from '../Index/Blocs/DataTableBloc'

class DetailView extends Component {
    source
    indexBloc = new IndexBloc()

    constructor(props) {
        super(props)
        this.state = {
            detail: []
        }
    }

    loadDetail = async () => {
        const query = {
            uuid: this.props.id
        }
        await this.indexBloc.fetchDetail(query, this.source.token)
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadDetail()
    }


    componentDidMount = () => {
        this.setTokenAPI()

        this.indexBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ detail: result.data.response })
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        })

    }

    componentWillUnmount() {
        this.indexBloc.detailChannel.unsubscribe()
    }

    render() {
        const { detail } = this.state
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            {/* <PegawaiSideBar active="kursus"/> */}

                            <Card className="">
                                <CardBody>
                                    <CardTitle>Detail kursus</CardTitle>
                                    <hr />
                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Nama kursus 
                                            </Label>
                                            <Label
                                                className="col-md-10 col-form-label"
                                            >
                                                {detail?.courses_name}
                                            </Label>
                                        </Row>

                                        <hr/>
                                        <Label># Tempat Kursus</Label>
                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Dalam / Luar Negeri
                                            </Label>
                                            <Label
                                                className="col-md-10 col-form-label"
                                            >
                                                {detail?.courses_domicile ? 'Luar Negeri' : 'Dalam Negeri'}
                                            </Label>                                                   
                                        </Row>
                                        { detail?.courses_domicile === 0 &&
                                            <Fragment>
                                                <Row className="mb-3">
                                                    <Label
                                                        className="col-md-2 col-form-label"
                                                    >
                                                        Provinsi
                                                    </Label>
                                                    <Label
                                                        className="col-md-10 col-form-label"
                                                    >
                                                        {detail?.place.courses_province_name}
                                                    </Label>                                                   
                                                </Row>
                                                <Row className="mb-3">
                                                    <Label
                                                        className="col-md-2 col-form-label"
                                                    >
                                                        Kota
                                                    </Label>
                                                    <Label
                                                        className="col-md-10 col-form-label"
                                                    >
                                                        {detail?.place.courses_city_name}
                                                    </Label>                                                   
                                                </Row>
                                            </Fragment>
                                        }
                                        { detail?.courses_domicile === 1 && 
                                            <Fragment>
                                                <Row className="mb-3">
                                                    <Label
                                                        className="col-md-2 col-form-label"
                                                    >
                                                        Negara
                                                    </Label>
                                                    <Label
                                                        className="col-md-10 col-form-label"
                                                    >
                                                        {detail?.place.courses_country_name}
                                                    </Label>                                                   
                                                </Row>
                                                <Row className="mb-3">
                                                    <Label
                                                        className="col-md-2 col-form-label"
                                                    >
                                                        Kota
                                                    </Label>
                                                    <Label
                                                        className="col-md-10 col-form-label"
                                                    >
                                                        {detail?.place.courses_city_text}
                                                    </Label>                                                   
                                                </Row>
                                            </Fragment>
                                        }
                                        <hr/>

                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Penyelanggara 
                                            </Label>
                                            <Label
                                                className="col-md-10 col-form-label"
                                            >
                                                {detail?.courses_organizer}
                                            </Label>
                                        </Row>


                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Tanggal Mulai 
                                            </Label>
                                            <Label
                                                className="col-md-10 col-form-label"
                                            >
                                                {detail?.courses_start_date}
                                            </Label>
                                        </Row>

                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Tanggal Selesai 
                                            </Label>
                                            <Label
                                                className="col-md-10 col-form-label"
                                            >
                                                {detail?.courses_end_date}
                                            </Label>
                                        </Row>

                                       

                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                File Kursus 
                                            </Label>
                                            <Label
                                                className="col-md-6 col-form-label"
                                            >
                                                <Preview
                                                    value={detail?.document}
                                                />
                                            </Label>
                                        </Row>
                                        <Row className="mb-3">
                                            <Col md="12">
                                                <Link to="/kepegawaian/home.html?kursus">
                                                    <Button color="danger" type="button"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                            </Col>
                                        </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </Fragment>
        )
    }

}

export default DetailView